/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockOpenIcon24Solid = forwardRef('SecurityLockOpenIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.444.9A5.544 5.544 0 0 0 12.9 6.444V8H5a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-6A4 4 0 0 0 15.1 8V6.444a3.344 3.344 0 0 1 6.687 0V7a1.1 1.1 0 0 0 2.2 0v-.556A5.544 5.544 0 0 0 18.444.9Zm-7.569 14.899a2 2 0 1 0-1.75 0v1.7a.875.875 0 1 0 1.75 0v-1.7Z" })));
});
